export default "__VITE_ASSET__Cip2W2f5__"